module.exports = __webpack_public_path__ + "img/review-writing.7506aed0.png";